import { __cClubService } from '@/services/client/__c.club.service'
import { useQuery } from '@tanstack/react-query'

export const useGetReviewCoolClubQuery = () => {
  return useQuery({
    queryKey: ['review-coolclub'],
    queryFn: () => __cClubService.getReviewCoolClub(),
  })
}
